import Page from './Page';
import PageHeader from './PageHeader';
import Breadcrumbs from './Breadcrumbs';

export default {
  Page,
  PageHeader,
  Breadcrumbs,
};
